<template>
  <generic-modal :modal-key="'post_game'" :has-extra-modal-class="'postgame_modal games modal_cont'"
                 @close="closeModal">
    <template slot="content">
      <div id="postgame_modal_games">
        <span v-if="correctAnswersForKeys() === 'ALL'">
        <img src="static/images/game_popups/face_glasses.png" class="face_img">
        <h1>{{ getTranslations.post_game_wow }}<br> {{ getTranslations.post_game_all_right }}</h1>
        <h2>{{ getTranslations.post_game_total_points }}</h2>
        <h3>{{ totalEarnedPoints }}</h3>
        </span>
        <span v-else-if="correctAnswersForKeys() === 'MIXED'">
        <img src="static/images/game_popups/face_glasses.png" class="face_img">
        <h1>{{ getTranslations.post_game_mixed }}<br> {{ getTranslations.post_game_mixed_answers }}</h1>
        <h2>{{ getTranslations.post_game_total_points }}</h2>
        <h3>{{ totalEarnedPoints }}</h3>
        </span>
        <span v-else>
        <img src="static/images/game_popups/face_lost.png" class="face_img">
        <h1>{{ getTranslations.post_game_lose }}<br> {{ getTranslations.post_game_all_lose }}</h1>
        <h2>{{ getTranslations.post_game_total_points }}</h2>
        <h3>{{ totalEarnedPoints }}</h3>
        </span>
        <p>{{ getTranslations.post_game_points_per_question }}</p>
        <div class="points_container">
          <div v-for="(item, index) in numberOfQuestionsPerRound" :key="index">
            <div class="points_box">
              <div class="progress_text"><span>{{ questionsPoints }}</span> {{ getTranslations.post_game_points }}</div>
              <div :class="['progressbar', getHomePlayerAnswersHistory(index)]">
                <div :id="[`progressId_${index}`]" class="progressbar__bar"
                     :data-percent="getHomePlayerAnswersHistory(index) === '' ? 0 : 100" style="width: 100%"></div>
              </div>
            </div>
          </div>
        </div>
        <span v-if="correctAnswersForKeys() !== 'ZERO' && !activeAddOnGameMode() && ['TRIPLE_POINTS_OR_LOSE', 'DOUBLE_POINTS_OR_LOSE'].includes(addOnMode.text) && activeAddOnGameButton()">
        <div  class="risk_title">
          {{ getTranslations.post_game_double_triple_lose }}
        </div>
        <div class="risk_text">
          {{ getTranslations.post_game_double_triple_lose_risk_the_points }}
        </div>
        </span>
        <span v-if="correctAnswersForKeys() !== 'ZERO' && !activeAddOnGameMode() && ['ONLY_DOUBLE', 'ONLY_TRIPLE'].includes(addOnMode.text) && activeAddOnGameButton()">
        <div  class="risk_title">
          {{ getTranslations.post_game_double_triple }}
        </div>
        <div class="risk_text">
          {{ getTranslations.post_game_double_triple_risk_the_points }}
        </div>
        </span>
        <span v-if="correctAnswersForKeys() !== 'ZERO' && !activeAddOnGameMode() && addOnMode.text === 'NO_WIN_LOSE' && activeAddOnGameButton()">
        <div  class="risk_title">
          {{ getTranslations.post_game_no_win_lose }}
        </div>
        <div class="risk_text">
          {{ getTranslations.post_game_no_win_lose_risk_the_points }}
        </div>
        </span>
        <button v-if="activeAddOnGameButton()" type="button" class="new_game_btn" @click.prevent="$emit('playPostGameAddOn')">{{ getTranslations.post_game_play_now }}</button>
        <button v-else type="button" class="new_game_btn" @click.prevent="$emit('playNewGame')">{{ getTranslations.post_game_new_game }}</button>

      </div>
    </template>
  </generic-modal>
</template>

<script>
/* eslint no-console: "off" */
/* games_postgame_modal.html */
import { mapGetters, mapState } from 'vuex';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  name: 'post-game',
  components: { GenericModal },
  data() {
    return {
      totalEarnedPoints: 0,
      correctAnswers: 0,
    };
  },
  created() {
    console.log('in PostGame created hook:');
    this.totalEarnedPoints = this.homePlayerTotalEarnedPoints;
    this.correctAnswers = this.homePlayerCorrectAnswersCSSClasses.filter(answer => answer === 'correct').length;
  },
  methods: {
    correctAnswersForKeys() {
      if (this.correctAnswers === 0) {
        return 'ZERO';
      } else if (this.correctAnswers < this.numberOfQuestionsPerRound) {
        return 'MIXED';
      }
      return 'ALL';
    },
    activeAddOnGameMode() {
      return this.addOnMode.hide;
    },
    getHomePlayerAnswersHistory(answerIndex) {
      const homePlayerAnswersHistory = this.homePlayerCorrectAnswersCSSClasses[answerIndex];
      return homePlayerAnswersHistory !== undefined ? homePlayerAnswersHistory : '';
    },
    closeModal() {
      this.$router.push('/home');
    },
    activeAddOnGameButton() {
      return !(this.addOnMode.hide || this.totalEarnedPoints === 0);
    },
  },
  computed: {
    ...mapState('common', [
      'addOnMode',
    ]),
    ...mapState('game', [
      'homeCorrectAnswers',
      'questionsPoints',
      'homePlayerCorrectAnswersCSSClasses',
      'numberOfQuestionsPerRound',
      'homePlayerTotalEarnedPoints',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/PostGame.vue